import {Shell} from '@/entryPoints/b2c/shell';
import productTile from '@/components/containers/plp/ProductTile';

// Legacy Plugins
import '@/vendor/owl.carousel.min.js';
import '@/vendor/owl.carousel.plugins.js';

// Legacy Modules
import productTileModule from '@/modules/ProductTile';
import slider from '../../modules/slider';

// Styling
import '@sassRoot/entryPoints/b2c/sale-clearance.scss';

class SaleAndClearance extends Shell {}

const sac = new SaleAndClearance({
  productTile,
});

sac.preLoadInits();
sac.initializeVue();

// Legacy foundation initialization
$(document).foundation();

$(document).ready(() => {
  sac.globalDocumentReadyInits();

  const sliders = $('[data-owl-slider]');
  window.sliderRefs = [];
  sliders.each((i, s) => {
    window.sliderRefs.push(slider($(s)));
  });

  if ($('.product-tile').length) {
    productTileModule(document);
  }
});

$(window).on('load', () => {
  sac.globalOnLoadInits();
});
